import { Input } from 'antd'
import { Controller } from 'react-hook-form'
import { inputDecimalNumber } from 'src/app/shared/utils'
interface IProps {
  control: any
  name: any
  placeholder: any
  integerLimit: number
  decimalLimit: number
  handleTrigger?: any
}

const CommonAmount = (props: IProps) => {
  const { control, name, placeholder, integerLimit, decimalLimit, handleTrigger } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Input
          {...field}
          status={fieldState?.error ? 'error' : ''}
          placeholder={placeholder}
          onChange={(e) => field.onChange(inputDecimalNumber(e, integerLimit, decimalLimit), { shouldValidate: true })}
          onBlur={(e) => {
            let e1 = e
            e1.target.value = e.target.value.trim()
            field.onChange(e1)
            handleTrigger && handleTrigger()
          }}
          suffix={'$'}
        />
      )}
    />
  )
}

export default CommonAmount
